import { directive as viewer } from "v-viewer";
import "viewerjs/dist/viewer.css";

export default defineNuxtPlugin((nuxtApp: any) => {
  // 客户端使用完整的viewer指令
  nuxtApp.vueApp.directive("viewer", viewer);
});
